import { connect, ConnectedProps } from 'react-redux';
import VoicemailTemplates from './voicemail-templates';
import {
  resetAssignCallOutcomeRequest,
  resetCreateCallLogsNoteRequest,
  resetCreateVoicemailTemplateRequest,
  resetDeleteVoicemailTemplateRequest,
  resetGetSignedUrlForVoicemailTemplateRequest,
  resetGetSignedUrlForVoicemailTemplateResponses,
  resetUpdateVoicemailTemplateRequest,
  setShowDialer,
} from '../../../../dialer-slice';
import { RootState } from '../../../../../../store/root-reducer';
import {
  createVoicemailTemplateRequest,
  deleteVoicemailTemplateRequest,
  getPreSignedUrlRequest,
  getSignedUrlForVoicemailTemplateRequest,
  getVoicemailTemplateListRequest,
  updateVoicemailTemplateRequest,
} from '../../../../extra-actions';
import {
  CreateVoicemailTemplateProps,
  GetVoicemailTemplateListProps,
  UpdateVoicemailTemplateProps,
} from '../../../../types';

const mapStateToProps = (state: RootState) => ({
  showDialer: state?.dialer?.showDialer,
  voicemailTemplateListResponse:
    state?.dialer?.getVoicemailTemplateListResponse,
  getVoicemailTemplateListRequestStatus:
    state?.dialer?.getVoicemailTemplateListRequest?.status,
  getSignedUrlForVoicemailTemplateResponses:
    state?.dialer?.getSignedUrlForVoicemailTemplateResponses ?? {},
  getSignedUrlForVoicemailTemplatePendingId:
    state?.dialer?.getSignedUrlForVoicemailTemplatePendingId,
  createVoicemailTemplateRequestStatus:
    state?.dialer?.createVoicemailTemplateRequest,
  updateVoicemailTemplateRequestStatus:
    state?.dialer?.updateVoicemailTemplateRequest,
  deleteVoicemailTemplateRequestStatus:
    state?.dialer?.deleteVoicemailTemplateRequest,
  getPreSignedUrlResponse: state?.dialer?.getPreSignedUrlResponse,
  getSignedUrlForVoicemailTemplateRequestStatus:
    state?.dialer?.getSignedUrlForVoicemailTemplateRequest,
  callLogsListCountsResponse: state?.dialer?.callLogsListCountsResponse,
  assignCallOutcomeRequestStatus: state?.dialer?.assignCallOutcomeRequest,
  createCallLogsNoteRequestStatus:
    state?.dialer?.createCallLogsNoteRequest?.status,
  isDemoAccount: state?.home?.isDemoAccount,
});

const mapDispatchToProps = {
  onMakeCallClick: (show: boolean) => setShowDialer(show),
  getVoicemailTemplateListRequest: (params: GetVoicemailTemplateListProps) =>
    getVoicemailTemplateListRequest(params),
  getSignedUrlForVoicemailTemplateRequest: (templateId: number) =>
    getSignedUrlForVoicemailTemplateRequest(templateId),
  resetGetSignedUrlForVoicemailTemplateRequest: () =>
    resetGetSignedUrlForVoicemailTemplateRequest(),
  createVoicemailTemplateRequest: (payload: CreateVoicemailTemplateProps) =>
    createVoicemailTemplateRequest(payload),
  sendGetPreSignedUrlRequest: (payload: {
    fileName: string;
    documentType: string;
    fileType: string;
    fileSize: number;
    metadata?: Record<string, any>;
  }) => getPreSignedUrlRequest(payload),
  resetCreateVoicemailTemplateRequest: () =>
    resetCreateVoicemailTemplateRequest(),
  updateVoicemailTemplateRequest: (params: {
    templateId: number;
    payload: UpdateVoicemailTemplateProps;
  }) => updateVoicemailTemplateRequest(params),
  deleteVoicemailTemplateRequest: (templateId: number) =>
    deleteVoicemailTemplateRequest(templateId),
  resetDeleteVoicemailTemplateRequest: () =>
    resetDeleteVoicemailTemplateRequest(),
  resetUpdateVoicemailTemplateRequest: () =>
    resetUpdateVoicemailTemplateRequest(),
  resetGetSignedUrlForVoicemailTemplateResponses: () =>
    resetGetSignedUrlForVoicemailTemplateResponses(),
  resetAssignCallOutcomeRequest: () => resetAssignCallOutcomeRequest(),
  resetCreateCallLogsNoteRequest: () => resetCreateCallLogsNoteRequest(),
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type IVoicemailTemplatesProps = ConnectedProps<typeof connector>;

export default connector(VoicemailTemplates);
